<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Gdzie nas znaleźć</h3>
    </app-contentpageheader>
    <app-maps />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../components/common/ContentPageHeader.vue";
import Footer from "../components/common/Footer.vue";
import Maps from "../components/common/GoogleMaps/Maps.vue";
export default {
  data() {
    return {
      backgroundImg: require("../assets/common/gdzie_nas_znalezc.jpg")
    };
  },
  components: {
    "app-maps": Maps,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
